import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";

export const Route = createFileRoute("/impressum")({
  head: () => ({
    meta: [
      { title: "Impressum – Energie Prime 360" },
      { name: "description", content: "Impressum und Anbieterkennzeichnung gemäß § 5 TMG." },
    ],
  }),
  component: ImpressumPage,
});

function ImpressumPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteNav />
      <main className="mx-auto max-w-3xl px-6 md:px-10 py-20 md:py-28">
        <Link to="/" className="eyebrow text-[var(--leaf)] hover:underline">← Zurück</Link>
        <h1 className="font-display text-4xl md:text-5xl mt-6 mb-10">Impressum</h1>
        <div className="space-y-6 text-base leading-relaxed text-foreground/85">
          <p className="font-semibold">Angaben gemäß § 5 TMG</p>
          <p>
            Energie Prime 360<br />
            Ein Produkt der<br /><br />
            Energie- &amp; Fördermittel Zentrum Deutschland GmbH<br />
            Fohling 24<br />
            33106 Paderborn<br />
            Deutschland
          </p>
          <p>
            <strong>Vertreten durch:</strong><br />
            Christoph Bachmann
          </p>
          <p>
            <strong>Anschrift des Verantwortlichen:</strong><br />
            Christoph Bachmann<br />
            Thunemeiershof 41<br />
            33102 Paderborn
          </p>
          <p>
            <strong>Kontakt:</strong><br />
            E-Mail: [E-Mail-Adresse ergänzen]<br />
            Telefon: 02524-9478183<br />
            Hotline: 01736339218
          </p>
          <h2 className="font-display text-2xl pt-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p>
            Christoph Bachmann<br />
            Thunemeiershof 41<br />
            33102 Paderborn
          </p>
          <h2 className="font-display text-2xl pt-4">Haftung für Inhalte</h2>
          <p>
            Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
            Vollständigkeit und Aktualität der bereitgestellten Informationen kann jedoch keine
            Gewähr übernommen werden.
          </p>
          <h2 className="font-display text-2xl pt-4">Haftung für Links</h2>
          <p>
            Diese Website kann Verweise auf externe Webseiten Dritter enthalten. Auf deren Inhalte
            besteht kein Einfluss. Für die Inhalte verlinkter Seiten sind ausschließlich deren
            Betreiber verantwortlich.
          </p>
          <h2 className="font-display text-2xl pt-4">Urheberrecht</h2>
          <p>
            Die auf dieser Website veröffentlichten Inhalte, Texte, Bilder, Grafiken, Logos und
            sonstigen Werke unterliegen dem deutschen Urheberrecht. Jede Verwendung außerhalb der
            Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung des jeweiligen
            Rechteinhabers.
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
